/* ============================================
   TURBO THEME — PRODUCT JS
   ============================================ */

'use strict';

// ---- Image zoom ----
(function initImageZoom() {
  const mainWrap = document.querySelector('.product-gallery__main');
  if (!mainWrap) return;

  const img = mainWrap.querySelector('img');
  if (!img) return;

  let zoomed = false;
  let startX, startY, translateX = 0, translateY = 0;

  mainWrap.style.cursor = 'zoom-in';

  mainWrap.addEventListener('dblclick', e => {
    if (!zoomed) {
      const rect = mainWrap.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = `${x}% ${y}%`;
      img.style.transform = 'scale(2)';
      mainWrap.style.cursor = 'zoom-out';
      zoomed = true;
    } else {
      img.style.transform = 'scale(1)';
      mainWrap.style.cursor = 'zoom-in';
      zoomed = false;
    }
  });

  mainWrap.addEventListener('mouseleave', () => {
    if (zoomed) {
      img.style.transform = 'scale(1)';
      mainWrap.style.cursor = 'zoom-in';
      zoomed = false;
    }
  });

  mainWrap.addEventListener('mousemove', e => {
    if (!zoomed) return;
    const rect = mainWrap.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    img.style.transformOrigin = `${x}% ${y}%`;
  });
})();

// ---- Sticky add to cart ----
(function initStickyATC() {
  const form = document.querySelector('form[data-product-form]');
  if (!form) return;

  const addBtn = form.querySelector('[data-add-to-cart]');
  if (!addBtn) return;

  const sticky = document.querySelector('.sticky-atc');
  if (!sticky) return;

  const observer = new IntersectionObserver(entries => {
    const isVisible = entries[0].isIntersecting;
    sticky.classList.toggle('visible', !isVisible);
  }, { threshold: 0.5 });

  observer.observe(addBtn);

  sticky.querySelector('[data-sticky-add]')?.addEventListener('click', () => {
    addBtn.click();
  });
})();
